<script setup lang="ts">
import BaseIcon from '@/components/ui/BaseIcon.vue';
import { useAppStore } from '@/stores/app';

const appStore = useAppStore();
</script>

<template>
  <!-- The live region stays in the DOM: screen readers only reliably announce
       content that changes inside a region they already know about. -->
  <div role="status">
    <transition name="toast-notification">
      <div v-if="appStore.toast" class="toast-notification">
        <BaseIcon v-if="appStore.toast.icon" :name="appStore.toast.icon" class="toast-notification__icon" />
        <span>{{ appStore.toast.message }}</span>
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
.toast-notification {
  align-items: center;
  background-color: $color-neutral-highest;
  border-radius: $radius-pill;
  box-shadow: $shadow-soft;
  color: $color-white;
  display: flex;
  font: $label-medium;
  gap: $spacing-2;
  left: $spacing-3;
  letter-spacing: $label-medium-spacing;
  margin-inline: auto;
  padding: $spacing-3 $spacing-5;
  position: fixed;
  right: $spacing-3;
  text-align: center;
  top: calc($spacing-4 + var(--status-bar-band, env(safe-area-inset-top)));
  width: fit-content;
  z-index: 10;

  &__icon {
    font-size: 20px;
  }

  &-enter-active,
  &-leave-active {
    transition:
      opacity 0.2s,
      translate 0.2s;
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;
    translate: 0 -8px;
  }
}
</style>
